import { render, staticRenderFns } from "./SumerianScene.vue?vue&type=template&id=bb4a8976&"
import script from "./SumerianScene.vue?vue&type=script&lang=js&"
export * from "./SumerianScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports